import apiService from './apiService';

// Notes engine client (Notes & Reminders, Fase 1). A note is a short free-form
// markdown capture — the user's "external brain". Retrieval is accent + case-
// insensitive KEYWORD search over title+content (BE `?search=`), NOT RAG.
export const noteService = {
    // List (or search) the caller's notes, newest-updated first.
    // → { notes: [{id,title,content,source,created_at,updated_at}], count, total }
    async list({ search, limit, offset } = {}) {
        const params = new URLSearchParams();
        if (search) params.set('search', search);
        if (limit != null) params.set('limit', String(limit));
        if (offset != null) params.set('offset', String(offset));
        const qs = params.toString();
        return apiService.get(`/api/notes${qs ? `?${qs}` : ''}`);
    },

    async create({ title, content, source = 'web' }) {
        return apiService.post('/api/notes', { title, content, source });
    },

    async update(id, patch) {
        return apiService.patch(`/api/notes/${id}`, patch);
    },

    async remove(id) {
        return apiService.delete(`/api/notes/${id}`);
    },

    async bulkDelete(noteIds) {
        return apiService.post('/api/notes/bulk-delete', { note_ids: noteIds });
    },

    // ── Attachments (Note attached document update #283) ────────────────────
    // A note LINKS documents that live in the File Manager — it never copies or
    // moves them, and detaching only breaks the link. `list` above already
    // returns each note's `attachments`, so these are for the editor's own
    // add/remove round-trips.

    async listAttachments(noteId) {
        return apiService.get(`/api/notes/${noteId}/attachments`);
    },

    async attachDocument(noteId, documentId) {
        return apiService.post(`/api/notes/${noteId}/attachments`, { document_id: documentId });
    },

    async detachDocument(noteId, documentId) {
        return apiService.delete(`/api/notes/${noteId}/attachments/${documentId}`);
    },

    // ── Collaboration (PAI Shared notes #259) ───────────────────────────────
    // Sharing grants FULL EDITING rights — there is no role to pass. `list`
    // above returns owned AND shared-in notes, each carrying is_owner /
    // is_shared / shared_with / shared_by.

    // target: { userId } for one Network contact, or { teamId } for a whole team.
    async share(noteId, { userId, teamId } = {}) {
        const body = teamId ? { team_id: teamId } : { invitee_user_id: userId };
        return apiService.post(`/api/notes/${noteId}/share`, body);
    },

    async unshare(noteId, userId) {
        return apiService.delete(`/api/notes/${noteId}/share/${userId}`);
    },
};

export default noteService;
